import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export class BlockReadMore {
    private readmoreItems: NodeListOf<HTMLElement>;

    constructor() {
        this.readmoreItems = document.querySelectorAll(".readmore-item");
        //this.initAnimations();
    }

    private initAnimations(): void {
        this.readmoreItems.forEach((item) => {
            const content = item.querySelector(".readmore-content");
            const svg = item.querySelector("svg");
            const heading = item.querySelector("h3");

            const isLargeScreen = window.innerWidth >= 800; // 50rem = 800px
            let movePercent = -55;

            if (isLargeScreen) {
                movePercent = -60;
            }

            if (!content || !svg) return;

            // Fade in the content
            gsap.fromTo(
                content,
                {
                    opacity: 0
                },
                {
                    opacity: 1,
                    duration: 0.15,
                    ease: "none",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 50%",
                        end: "bottom 50%",
                        toggleActions: "play reverse play reverse",
                    },
                }
            );

            // Slide in the SVG from the left
            gsap.fromTo(
                svg,
                {
                    xPercent: movePercent
                },
                {
                    xPercent: -50,
                    duration: 0.15,
                    ease: "none",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 50%",
                        end: "bottom 50%",
                        toggleActions: "play reverse play reverse",
                    },
                }
            );

            // Add underline class to h2 when scrolled into view
            if (heading) {
                gsap.fromTo(
                    heading,
                    {
                        className: "text-[26px] md:text-[32px] font-medium leading-tight mt-6 mb-4 decoration-[2px] underline-offset-[3px]",
                    },
                    {
                        className: "text-[26px] md:text-[32px] font-medium leading-tight mt-6 mb-4 decoration-[2px] underline-offset-[3px] underline", // Tailwind underline class
                        duration: 0.15, // optional, just to trigger class toggle
                        scrollTrigger: {
                            trigger: item,
                            start: "top 50%",
                            end: "bottom 50%",
                            toggleActions: "play reverse play reverse",
                        },
                    }
                );
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new BlockReadMore();
});